import { CashTypeEnum } from "../enums/CashTypeEnum";
import { WorkloadFlowEnum } from "../enums/WorkloadFlowEnum";

export class CurrencyBalance {

    public currency: string;
    public cashIn: number;
    public cashOut: number;
    public balance: number;

    constructor() { }

    public parse(obj: any) {

        if (obj.Currency) this.currency = obj.Currency;
        if (obj.CashIn != null) this.cashIn = obj.CashIn;
        if (obj.CashOut != null) this.cashOut = obj.CashOut;
        if (obj.Balance != null) this.balance = obj.Balance;
    }
}